'use es6';

import isEmpty from 'hs-lodash/isEmpty';
import { push } from 'FormsUI/actions/HistoryActions';
import { updateParams } from 'FormsUI/actions/ReactRouter';
import { updateMetaData } from 'FormsCommonComponents/form-definition/utils/MetaDataUtils';
import { LEGAL_CONSENT_OPTIONS_KEY } from 'FormsCommonComponents/constants/LegalConsent';
import { createForm as createFormFromClient } from 'FormsUI/api/Forms';
import { getV2EditorRoute } from 'FormsUI/lib/RouteGenerators';
import { getIsLegalConsentEnabled } from 'forms-utils-lib/dataPrivacySettings/selectors/DataPrivacySettings';
import { getSelectedType, getSelectedBusinessUnitId } from 'FormsUI/selectors/FormCreation';
import { hasMarketableContactsWriteScope, hasMarketableContactsAccessScope } from 'FormsUI/selectors/Scope';
import { REQUEST_FORM_CREATION, SUCCEED_CREATING_FORM } from 'FormsUI/actions/formCreation/formCreationActions';
import { buildForm } from 'FormsUI/actions/FormCreation';
import { generateTimestampedName } from 'FormsUI/utils/FormCreationUtils';
import { getDefaultLegalConsentOption } from 'FormsUI/selectors/legalConsentOptions';
import convertNonHubSpotFormToHubSpotFormError from './convertNonHubSpotFormToHubSpotFormError';
const requestFormCreation = () => ({
  type: REQUEST_FORM_CREATION
});
const maybeSetMarketingContacts = (definition, state) => Object.assign({}, hasMarketableContactsAccessScope(state) ? {
  createMarketableContact: hasMarketableContactsWriteScope(state)
} : {}, definition);
export const convertNonHubSpotFormToHubSpotForm = (definition = {}, attemptNumber = 1, isCollectedForm = false, options = {}) => (dispatch, getState) => {
  const state = getState();
  const selectedType = getSelectedType(state);
  const businessUnitId = getSelectedBusinessUnitId(state);
  const legalConsentEnabled = getIsLegalConsentEnabled(state);
  const completeFormDefinition = isEmpty(definition) ? buildForm(getState, attemptNumber) : Object.assign({}, definition, {
    name: generateTimestampedName(attemptNumber, definition.name),
    businessUnitId
  });
  if (legalConsentEnabled) {
    const defaultLegalConsentOption = getDefaultLegalConsentOption(state);
    if (defaultLegalConsentOption) {
      completeFormDefinition.metaData = updateMetaData(completeFormDefinition.metaData, LEGAL_CONSENT_OPTIONS_KEY, JSON.stringify(defaultLegalConsentOption));
    }
  }
  if (selectedType) {
    completeFormDefinition.metaData = updateMetaData(completeFormDefinition.metaData, 'embedType', selectedType);
  }
  const builtForm = maybeSetMarketingContacts(completeFormDefinition, getState());
  dispatch(requestFormCreation());
  return createFormFromClient(builtForm).then(newForm => {
    dispatch({
      type: SUCCEED_CREATING_FORM
    });
    if (isCollectedForm) {
      dispatch(updateParams({
        shouldShowShareDialog: true
      }, true));
    }
    dispatch(push(getV2EditorRoute(newForm.guid, 'form', undefined, options)));
  }, ({
    xhr
  }) => {
    dispatch(convertNonHubSpotFormToHubSpotFormError({
      xhr,
      attemptNumber,
      definition
    }));
  });
};
export default convertNonHubSpotFormToHubSpotForm;